// actions/comment_form.js
export const OPEN_COMMENT_FORM = 'OPEN_COMMENT_FORM';
export const OPEN_COMMENT_EDIT_FORM = 'OPEN_COMMENT_EDIT_FORM';
export const CLOSE_COMMENT_FORM = 'CLOSE_COMMENT_FORM';
export const OPEN_REPLY_COMMENT_FORM = 'OPEN_REPLY_COMMENT_FORM';
export const CLOSE_REPLY_COMMENT_FORM = 'CLOSE_REPLY_COMMENT_FORM';

export const openCommentForm = () => ({
  type: OPEN_COMMENT_FORM,
});

export const openCommentEditForm = (status) => ({
  type: OPEN_COMMENT_EDIT_FORM,
  status
});

export const openReplyCommentForm = (id) => {
  return {
    type: OPEN_REPLY_COMMENT_FORM,
    id: id
  };
};

export const closeReplyCommentForm = () => {
  return {
    type: CLOSE_REPLY_COMMENT_FORM,
    id: null
  };
};


export const closeCommentForm = () => ({
  type: CLOSE_COMMENT_FORM,
});
